import {
  Flex,
  InputSearch,
  PaginationPerPageSelect,
  SearchContext,
} from 'dash-ui';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ExternalSalesPageHeader = () => {
  const { t } = useTranslation(['common', 'pages']);
  const { setSearchSlug } = useContext(SearchContext);

  const [search, setSearch] = useState('');

  return (
    <Flex alignItems="center" w="100%" px={6} py={4}>
      <InputSearch
        flex={1}
        value={search}
        onChange={(event) => {
          setSearch(event.target.value);
          setSearchSlug(event.target.value);
        }}
        onClear={() => {
          setSearch('');
          setSearchSlug('');
        }}
        w="100%"
        placeholder={t('common:labels.search') || ''}
      />
      <PaginationPerPageSelect
        w={130}
        mx={3}
        label={t('common:labels.show') || ''}
      />
    </Flex>
  );
};

export default ExternalSalesPageHeader;
